import { render, staticRenderFns } from "./DetailQR.vue?vue&type=template&id=75ace3f5&scoped=true&"
import script from "./DetailQR.vue?vue&type=script&lang=js&"
export * from "./DetailQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ace3f5",
  null
  
)

export default component.exports